import { render, staticRenderFns } from "./BookingTimeSlot.vue?vue&type=template&id=65c53ed2&"
import script from "./BookingTimeSlot.vue?vue&type=script&lang=js&"
export * from "./BookingTimeSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports